import React, { Component } from 'react';
import '../../../styles/variables.css';
import {NavLink} from 'react-router-dom';
import '../BackendMain/BackendMain.css';
import logo from '../../../images/logo-light.png';
import {connect} from 'react-redux';
import {startLogout} from '../../../actions/auth_actions';

class BackendSidenav extends Component {

    logout = () =>{
        this.props.logout();
        window.location.reload(true);
    }
    render(){
        return(
            <div className="b-sidenav">
                <img className="b-d-logo" src={logo} alt="bc-logo"/>
                <nav>
                    <ul className='Navbar__list'>
                        <li className='Navbar__link'>
                            {!this.props.company.onCreate ? <NavLink activeClassName="active" className='Navbar__link' to='/company/vacancies'>
                                Vacantes
                            </NavLink> : null}
                        </li>
                        <li className='Navbar__link'>
                        {!this.props.company.onCreate ? <NavLink activeClassName="active" className='Navbar__link' to='/company/mycompany'>
                                Empresa
                            </NavLink> : null}
                        </li>
                        <li className='Navbar__link'>
                            <button className='b-d-button Navbar__link' onClick={this.logout} >
                                Logout
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    logout: () => (dispatch(startLogout()))
})
const mapStateToProps = (state) => ({
    auth: state.auth.uid,
    company: state.company
});
export default connect(mapStateToProps, mapDispatchToProps)(BackendSidenav);